import { render, staticRenderFns } from "./Brukstorget.vue?vue&type=template&id=3a219ef9&scoped=true"
import script from "./Brukstorget.vue?vue&type=script&lang=js"
export * from "./Brukstorget.vue?vue&type=script&lang=js"
import style0 from "./Brukstorget.vue?vue&type=style&index=0&id=3a219ef9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a219ef9",
  null
  
)

export default component.exports